module.exports = __webpack_public_path__ + "img/file-copy-outline-rounded-blue.d8a05c2d.svg";